export default {
    url: 'battery-backup-for-home',
    include: ['us', 'ca'],
};
